
CheckoutV2.Cart.SaveForLater = function(checkout, cart) {
	var saveForLater = this;
	
	this.$wrap = $('.saved-for-later');
	
	this.wishListID = 0;
	
	this.storageEnabled = true;
	
	this.init = function() {	
		saveForLater.toggleDisplay();
		
		try {
			if (sessionStorage.savedForLater) {
				var clientSavedItems = JSON.parse(sessionStorage.savedForLater);
				if  (Object.keys(clientSavedItems).length) {
					saveForLater.loadClientSavedItems(clientSavedItems);
				}
			}
		} catch(e) {
			saveForLater.storageEnabled = false;
		}
		
		if (checkout.session.isLoggedIn()) {
			saveForLater.loadWishListSavedItems();
		}
		
		saveForLater.listen();
	};
	
	this.listen = function() {
		$('.my-cart').on('click', '.saveForLater', function(e) {
			e.preventDefault();
			saveForLater.addToSaved(cart.getItemFromInput($(this)));
		});
		
		$('.saved-for-later').on('click', '.moveToWishList, .js-wish-list-modal', function(e) {
			e.preventDefault();
			var item = cart.getSavedItemFromInput($(this));
			saveForLater.moveToWishList(item);
		});
		
		$('.saved-for-later').on('click', '.moveToCart', function(e) {
			e.preventDefault();
			var item = cart.getSavedItemFromInput($(this));
			saveForLater.moveToCart(item);
		});
		
		$('.saved-for-later').on('click', '.removeSavedItem', function(e) {
			e.preventDefault();
			var item = cart.getSavedItemFromInput($(this));
			saveForLater.removeSavedItem(item);
		});
		
		$('.saved-for-later').on('addedToWishList', function(e, productKey) {
			saveForLater.removeSavedItem(cart.savedItems[productKey]);
		});
		
		$('.saved-for-later').on('change', '.saved-item-qty', function(){
			var $this = $(this),
				item = cart.getSavedItemFromInput($this),
				qty = ( parseInt($this.val()) || 1 );
					
			if (qty < 0) {
				qty = 1;	
			}
			
			if (item && qty > 0) {
				item.loading('Updating Item Quantity');
				
				$this.val(qty);
				
				// update session storage
				if (saveForLater.storageEnabled) {
					var clientSavedItems = JSON.parse(sessionStorage.savedForLater);
					clientSavedItems[saveForLater.getProductKey(item.productID, item.data.pdk)].qty = qty;
					sessionStorage.savedForLater = JSON.stringify(clientSavedItems);
				}
				
				// update wish list
				var product = {};
				product[item.productID] = qty;
				saveForLater.wishListUpdate(product, item.data.pdk);
				
				item.changeQty(qty);
				
				$('#saved-item-'+saveForLater.getProductKey(item.productID, item.data.pdk)).find('.saved-item-qty').focus();
				
				item.loading(false);
			}
			
		});
		
		$('.saved-for-later').on('input propertychange', '.saved-item-qty', function() {
			var $el = $(this),
				item = cart.getSavedItemFromInput($el);
			
			item.disableLinks();
				
			checkout.delayChange($el, (Modernizr.touch ? 2000 : 1000), function() {
				$el.blur();
			});
		});
		
	};
	
	this.addToSaved = function(cartItem) {
		var productKey = saveForLater.getProductKey(cartItem.productID, cartItem.data.pdk);
		
		if (saveForLater.storageEnabled) {
			try {
				// add to session storage
				var clientSavedItems = sessionStorage.savedForLater ? JSON.parse(sessionStorage.savedForLater) : {};
				clientSavedItems[productKey] = {"productID": cartItem.productID, "qty": cartItem.data.qty};
				if (cartItem.data.pdk) {
					clientSavedItems[productKey].pdk = cartItem.data.pdk;
				}
				sessionStorage.savedForLater = JSON.stringify(clientSavedItems);
			} catch (e) {
				saveForLater.storageEnabled = false;
			}
		}

		// update wish list
		var product = {};
		product[cartItem.productID] = cartItem.data.qty;
		saveForLater.wishListUpdate(product, cartItem.data.pdk);
		
		// add to saved for later, if not already there
		if (!cart.savedItems[cartItem.productID]) {
			new CheckoutV2.Cart.SaveForLater.Item(checkout, cart).add(cartItem, productKey);
		}
		
		cart.saveForLater.toggleDisplay();
		
		// remove from cart
		cartItem.remove();
	};
	
	this.moveToCart = function(savedItem) {
		// add qty for add to cart
		var productKey = saveForLater.getProductKey(savedItem.productID, savedItem.data.pdk);
		$('#saved-item-'+productKey).find(".product-info").append(
            $("<input>")
                .prop("type", "hidden")
                .prop("name", "qty_box1_" + savedItem.data.productID)
                .addClass("qty tmpQty")
                .val(savedItem.data.qty)
        );
		
		// check for pdk
		var extraParams = {};
		if (savedItem.data.pdk) {
			extraParams.pdk1 = savedItem.data.pdk;
		}
		
		addToCart(savedItem.productID, extraParams);
		
		// remove saved item
		saveForLater.removeSavedItem(savedItem);
	};
	
	this.moveToWishList = function(savedItem) {
		// add qty for add wishlist
		var productKey = saveForLater.getProductKey(savedItem.productID, savedItem.data.pdk);
		$('#saved-item-'+productKey).find(".product-info").append(
            $("<input>")
                .prop("type", "hidden")
                .prop("name", "qty_box1_" + savedItem.data.productID)
                .addClass("qty tmpQty")
                .val(savedItem.data.qty)
        );
		if (savedItem.data.pdk) {
			$('#saved-item-'+productKey).find(".product-info").append(
	            $("<input>")
	                .prop("type", "hidden")
	                .prop("id", "pdk_" + savedItem.data.productID)
	                .val(savedItem.data.pdk)
	        );
		}
		addToWishList(savedItem.data.productID);
		// remove saved item, handled by custom event above, called from addToCart
	};
	
	this.removeSavedItem = function(savedItem) {
		var productKey = saveForLater.getProductKey(savedItem.productID, savedItem.data.pdk);
		
		if (saveForLater.storageEnabled) {
			// remove from session storage
			var clientSavedItems = sessionStorage.savedForLater ? JSON.parse(sessionStorage.savedForLater) : {};
			delete clientSavedItems[productKey];
			sessionStorage.savedForLater = JSON.stringify(clientSavedItems);
		}
		
		if (checkout.session.isLoggedIn()) {
		    var formData = {
				'action'      : "deleteItems",
				'wishList'    : saveForLater.wishListID, 
				'products'    : JSON.stringify([savedItem.productID]),
			};
			
			if (savedItem.data.pdk)
				formData.pdk = savedItem.data.pdk;
			
			$.ajax({
				'url'      : "/WishList/",
				'cache'    : false,
				'type'     : "POST",
				'dataType' : "json",
				'data'     : formData
			}).done(function(data) {
				// remove item from saved list
				savedItem.remove();
				cart.saveForLater.toggleDisplay();
			});
		} else {
			// remove item from saved list
			savedItem.remove();
			cart.saveForLater.toggleDisplay();
		}
	};
	
	this.clearSessionStorage = function() {
		if (saveForLater.storageEnabled) {
			sessionStorage.removeItem('savedForLater');
		}
	};
	
	this.loadClientSavedItems = function(clientItems) {
		return checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'getClientSavedItems',
				'items': JSON.stringify(clientItems),
			}
		}).done(function(response) {
			//console.log('getClientSavedItems: ', response);
			$.each(response.data, function(i, itemResponse) {
				var productKey = saveForLater.getProductKey(itemResponse.item.productID, itemResponse.item.pdk);
				if (!cart.savedItems[productKey]) // add if not already there
					new CheckoutV2.Cart.SaveForLater.Item(checkout, cart).add(itemResponse, productKey);
			});
			cart.saveForLater.toggleDisplay();
			saveForLater.syncWishList(false, true);
		});
	};
	
	this.loadWishListSavedItems = function(toggleDisplay) {
		toggleDisplay = (typeof toggleDisplay === 'undefined') ? true : toggleDisplay;
		return checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'getWishListSavedItems',
			}
		}).done(function(response) {
			//console.log('getWishListSavedItems: ', response);
			$.each(response.data, function(i, itemResponse) {
				if (!saveForLater.wishListID)
					saveForLater.wishListID = itemResponse.wishListID;
				var productKey = saveForLater.getProductKey(itemResponse.item.productID, itemResponse.item.pdk);
				if (!cart.savedItems[productKey]) // add if not already there
					new CheckoutV2.Cart.SaveForLater.Item(checkout, cart).add(itemResponse, productKey);
			});
			if (toggleDisplay) {
				cart.saveForLater.toggleDisplay();
			}
			saveForLater.syncWishList(true, false);
		});
	};
		
	this.toggleDisplay = function(hide) {
        hide = (typeof hide === 'undefined') ? false : hide;

        if( Object.keys( cart.savedItems ).length && !hide && checkout.currentStepName() != 'review') {
            saveForLater.$wrap
                .removeClass( "js-hide" )
                .show();
        }
        else {
            saveForLater.$wrap
                .addClass( "js-hide" )
                .hide();
        }

	};
	
	this.syncWishList = function(updateClient, updateWishList) { // sync saved for later items
		updateClient = (typeof updateClient === 'undefined') ? true : updateClient;
		updateWishList = (typeof updateWishList === 'undefined') ? true : updateWishList;
		var products = {};
		for (id in cart.savedItems) {
			var data = cart.savedItems[id].data;
			products[data.productID] = [ { "qty": data.qty, "pdk": data.pdk } ];
			
			// update session storage
			if (updateClient && saveForLater.storageEnabled) {
				var clientSavedItems = sessionStorage.savedForLater ? JSON.parse(sessionStorage.savedForLater) : {};
				var productKey = saveForLater.getProductKey(data.productID, data.pdk);
				clientSavedItems[productKey] = {"productID": data.productID, "qty": data.qty};
				if (data.pdk) {
					clientSavedItems[productKey].pdk = data.pdk;
				}
				sessionStorage.savedForLater = JSON.stringify(clientSavedItems);
			}
			
		}
		
		// update wishlist, if logged in
		if (updateWishList) {
			saveForLater.wishListUpdate(products);
		}
	};
	
	this.wishListUpdate = function(products, pdk) {
		if (checkout.session.isLoggedIn() && Object.keys(products).length) { 
		    var formData = {
				'action'      : "addItems",
				'wishLists'   : JSON.stringify(new Array()), 
				'newWishList' : "Cart Saved For Later",
				'products'    : JSON.stringify(products),
				'setQty'      : 1,
			};
			
			if (pdk)
				formData.pdk = pdk;
		
			$.ajax({
				'url'      : "/WishList/",
				'cache'    : false,
				'type'     : "POST",
				'dataType' : "json",
				'data'     : formData
			}).done(function(data) {
				if (data && data.length) {
					if (!saveForLater.wishListID)
						saveForLater.wishListID = data[0];
				}
			});
		}
	}
	
	this.getProductKey = function(productID, pdk) {
		var rtn = productID;
		if (pdk)
			rtn += pdk;
		return rtn;
	}
	
	this.init();
};

